import { describe, it } from 'mocha'
import { expect } from 'chai'

import getElementXml from '../../helpers/features/getElementXml.js'

import generateColumnsDescription from './columns.js'

describe('generateColumns()', () => {
  it('should generate columns description', () => {
    expect(generateColumnsDescription(tag, [
      {
        value: 'Test',
        type: String,
        width: 25
      },
      {
        value: 1000,
        type: Number,
        width: 10
      }
    ])).to.equal(
    	'<cols><col min="1" max="1" width="25" customWidth="1"/><col min="2" max="2" width="10" customWidth="1"/></cols>'
    )
  })
})

function tag(tagName, attributes, innerXml) {
  return getElementXml('xl/worksheets/sheet{id}.xml', tagName, attributes, innerXml, 0, {}, {}, [])
}